export enum RouteQueryStringKeys {
  EMAIL = "email",

  /** Used by Auth0 when redirecting back with an error. */
  AUTH0_ERROR_DESCRIPTION = "error_description",
  COMMENT_ID = "comment-id",
  DATA_TAB_LAYOUT = "data-tab-layout",
  DISPLAY_MODE = "display-mode",
  PAGE = "page",
  REDIRECT = "redirect",
  SEARCH = "search",
  SORT = "sort",
  STATUS = "status",
  SUPPLIER = "supplier",
  TAB = "tab",
  TAB_SECONDARY = "tab-secondary",
  TAG_TYPE_ID = "tag-type-id",
  TASK_ID = "task-id",
  TOKEN = "token",
  USER_VERIFICATION_UUID = "verification-uuid",
  UUID = "uuid",
  VERIFICATION_NONCE = "nonce",
  VIEW_ID = "view-id",
  VIEW_TYPE = "view-type",
  SHOW_VARIANTS = "show-variants",
  WORKFLOW_ID = "workflow-id",
  WORKFLOW_PREVIEW_ID = "workflow-preview-id",
  // Used in `request for email` page
  SOURCE = "source",
  JOB_UUID = "job-uuid",
  TENANT_UUID = "tenant-uuid",
  TENANT_SHORT_UUID = "tenant-uuid-short",

  // Blueprint page
  BLUEPRINT_AUTOFOCUS_NAME = "blueprint-autofocus-name",

  // Blueprint import page
  IMPORT_MODE = "import-mode",
  WORKFLOW_TEMPLATE_ID = "workflow-template-id",
  // Workflow intake
  WORKFLOW_INTAKE_CONTEXT = "workflow-intake-context",
  WORKFLOW_INTAKE_OPEN = "workflow-intake-open",
}

export enum BlueprintImportModeQueryStringValues {
  DEFAULT = "default",
  NEW_VERSION = "new-version",
  NEW_VARIANT = "new-variant",
}

export enum RoutePaths {
  HOME = "/",

  WORKSPACE = "/workspace",

  CREDENTIALS_ERROR = "/credentials-error",

  // My work
  MY_TASKS = "/my/tasks",

  // Tasks
  ASSIGNED_TASKS = "/assigned-tasks",

  // Starred
  STARRED = "/starred",
  DOCUMENTS = "/documents",

  // Blueprints
  BLUEPRINTS = "/blueprints",

  // TODO (anthony): Rename these.
  GENERATE = "/templates/generate",
  IMPORT = "/templates/import",

  // Custom fields
  CUSTOM_FIELDS = "/custom-fields",

  // Spectrum forms
  SPECTRUM_FORMS = "/forms", // DELETE
  SPECTRUM_FORM_BUILDER = "/forms/form-builder", // DELETE
  SPECTRUM_FORM_GENERATE = "/forms/generate", // DELETE?

  // Tags
  TAGS = "/tags",

  // People and Teams
  PEOPLE = "/people",
  TEAMS = "/teams",

  // ADMIN
  ADMIN = "/admin",
  SYNC_LOGS = "/admin/sync-logs",
  BULK_INVITE = "/admin/bulk-invite",

  // OAuth redirects
  // ===============
  // These prefixes must stay in sync with OAUTH_CALLBACK_ROUTE_PREFIX.
  OAUTH_REDIRECT_BOX = "/callback/box",
  OAUTH_REDIRECT_DOCUSIGN = "/callback/docusign",
  OAUTH_REDIRECT_DOCUSIGN_DEVELOPER = "/callback/docusign-developer",

  // Unauthenticated
  LOGIN = "/login",
  LOGIN_SSO = "/login-sso",
  SIGN_UP = "/sign-up-regrello-app", // (hchen): Make the sign up URL a little more difficult to guess per Derek's suggestion
  INVITE_SENT = "/invite-sent",
  INVITE_REQUEST = "/invite-request",
  PASSWORD_RESET = "/reset-password",
  PASSWORD_RESET_SENT = "/password-reset-sent",
  PASSWORD_RESET_REQUEST = "/password-reset-request",
  MFA_RESET_SENT = "/mfa-reset-sent",
  MFA_RESET_REQUEST = "/mfa-reset-request",
  MFA_RESET = "/mfa-reset",
  VERIFICATION_SENT = "/verification-sent",
  UNSUBSCRIBE = "/unsubscribe",

  // Regrello-Only
  INTERNAL_GRANULAR_ACCESS = "/internal/granular_access",

  // Submit task without logging in (webform)
  SUBMISSION = "/submission",

  // Device verification flow.
  REQUEST_VERIFICATION = "/request-verification",
  CONFIRM_VERIFICATION = "/confirm-verification",

  // Developer-only page to facilitate testing.
  DEVELOPER = "/developer",

  // New data source page
  NEW_DATA_SOURCE = "/admin/new-data-source",

  // Edit data source page
  EDIT_DATA_SOURCE = "/admin/edit-data-source",
}

export enum RoutePathsWithId {
  BLUEPRINTS = "/blueprints",
  LATEST_WORKFLOW_TEMPLATE = "/blueprint/latest",

  // People and Teams.

  /**
   * `PEOPLE` must match the format of `model/user.go#GetPersonDetailViewDeepLinkTail` for search
   * results to link correctly from Typesense.
   */
  PEOPLE = "/people",

  /**
   * `TEAMS` must match the format of `model/team.go#GetTeamDetailViewDeepLinkTail` for search
   * results to link correctly from Typesense.
   */
  TEAMS = "/teams",

  // Workflow Pages
  WORKFLOW = "/workflow",
  WORKFLOW_INTAKE = "/workflow-intake",
  WORKFLOW_TEMPLATE = "/workflow-template",
}
